import { useMemo } from 'react';
// Mui
import { Box, Theme } from '@mui/material';
// Check
import { Check as CheckIcon } from '@mui/icons-material';
// Utilities
import { generateAttrForTesting } from 'app/utilities/Utilities';
// Constants
import { NO_COLOR_VALUE } from 'app/App.constants';
// Utils
import useColorPaletteContext from './utils/useColorPaletteContext';

type Props = {
  color: string;
  onClick?: (color:string) => void;
}

const ColorPaletteItem = ({ color, onClick }:Props) => {
  const { showNoColorValue, activeColors = [] } = useColorPaletteContext();

  const isActive = activeColors.includes(color);
  const isNoColorValue = color === NO_COLOR_VALUE;

  const sx = useMemo(() => {
    const defaultSx = {
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      width: 32,
      height: 32,
      borderRadius: '50%',
      color: 'white',
      overflow: 'hidden',
      '&:hover': {
        cursor: onClick ? 'pointer' : 'default'
      }
    }
    if ( showNoColorValue && isNoColorValue ) {
      return {
        ...defaultSx,
        border: (theme:Theme) => `2px solid ${isActive
          ? theme.palette.primary.main
          : theme.palette.grey[500]
        }`,
        '&::after': {
          content: '""',
          width: 2,
          height: 40,
          position: 'absolute',
          backgroundColor: (theme:Theme) => isActive
            ? theme.palette.primary.main
            : theme.palette.grey[500]
          ,
          transform: 'rotate(45deg)'
        }
      }
    }
    return defaultSx;
  }, [onClick, showNoColorValue, isActive, isNoColorValue]);

  const renderIcon = isActive && !isNoColorValue ? <CheckIcon /> : null;

  return (
    <Box
      {...generateAttrForTesting('action', 'box-color', color)}
      sx={sx}
      className={`bg-${color}`}
      onClick={onClick ? () => onClick(color) : undefined}
    >{renderIcon}</Box>
  )
}

export default ColorPaletteItem;
